import { Alert } from '~/components/ui/alert.tsx';
import { cn } from '~/styles/extended-theme';

export function GeneralValidationError({ formError }: { formError?: string }) {
  if (!formError) return null;

  return (
    <div className="pb-4">
      <Alert title="Validation Error" variant="destructive" description={formError} />
    </div>
  );
}

export function GeneralValidationErrors({ formErrors }: { title?: string; formErrors?: string[] }) {
  if (!formErrors) return null;

  return (
    <FieldErrors errors={formErrors} containerClassName="my-6" errorTextClassName="text-body1" />
  );
}

export type ListOfErrors = (string | null | undefined)[] | null | undefined;

export function FieldErrors({
  id,
  errors,
  containerClassName,
  errorTextClassName,
}: {
  errors?: ListOfErrors;
  id?: string;
  containerClassName?: string;
  errorTextClassName?: string;
}) {
  const errorsToRender = errors?.filter(Boolean);
  if (!errorsToRender?.length) return null;
  return (
    <ul id={id} className={cn('flex flex-col gap-1', containerClassName)}>
      {errorsToRender.map((e) => (
        <li key={e} className={cn('text-[10px] text-foreground-danger', errorTextClassName)}>
          {e}
        </li>
      ))}
    </ul>
  );
}
